import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';

import {notify} from 'common/notify';
import Loader from '../common/Loader';
import * as selector from '../../selectors';
import * as action from '../../actions';
import * as enums from '../../enums';
import pluralize from 'common/helpers/pluralize';

const mapStateToProps = state => {
	return {
		bookings: selector.getBookings(state),
		myBookings: selector.getMyBookings(state),
		tables: selector.getTables(state),
		intervals: selector.getIntervals(state),
		settings: selector.getSettings(state),
		selectedTableId: selector.getSelectedTableId(state),
		selectedIntervals: selector.getSelectedIntervals(state),
		showSwipe: selector.getSwipeStatus(state),
	};
};
const mapDispatchToProps = dispatch => {
	return bindActionCreators({
		loadBookings: action.loadBookings.request,
		loadTables: action.loadTables.request,
		selectIntervals: action.selectIntervals,
		unselectIntervals: action.unselectIntervals,
		warn: notify.warning,
		swipeIsShown: action.swipeIsShown,
	}, dispatch);
};

@connect(mapStateToProps, mapDispatchToProps)
export default class extends Component {
	static propTypes = {
		date: PropTypes.string,
		bookings: PropTypes.object,
		myBookings: PropTypes.object,
		tables: PropTypes.object,
		settings: PropTypes.object,
		intervals: PropTypes.object,
		loadBookings: PropTypes.func,
		loadTables: PropTypes.func,
		selectIntervals: PropTypes.func,
		unselectIntervals: PropTypes.func,
		selectedTableId: PropTypes.number,
		selectedIntervals: PropTypes.array,
		showSwipe: PropTypes.bool,
		swipeIsShown: PropTypes.func,
		warn: PropTypes.func,
	};

	constructor(props) {
		super(props);
		this.state = {
			showSwipe: true,
		};
	}

	componentDidMount() {
		this.props.loadTables();
		this.props.loadBookings({date: this.props.date});

		setTimeout(() => {
			this.props.swipeIsShown();
		}, 5000);
	}

	onSelectCell = (table_id, date) => {
		this.props.selectIntervals({table_id, intervals: [date]});
	};

	onUnselectCell = date => {
		this.props.unselectIntervals({intervals: [date]});
	};

	onSelectHookahHour = (table_id, date) => {
		const intervals = this.getHookahHourIntervals(table_id, date);
		if (intervals) {
			this.props.selectIntervals({
				table_id,
				intervals,
				group_id: moment(date).format('HHmm'),
			});
		}
	};

	onUnselectGroup = group_id => {
		this.props.unselectIntervals({group_id});
	};

	getHookahHourIntervals = (table_id, date) => {
		const {
			settings: {interval, hookahHour}
		} = this.props;

		let intervals = [date];

		// walk down and up the given interval until we fill hour range
		let fail = false;
		let i_max = Math.floor(hookahHour/interval);
		let i_date;
		let i = 1;
		while (intervals.length<i_max && !fail) {
			i_date = moment(date).add({minutes: interval*i}).toDate();
			if (this.isCellAvailable(table_id, i_date)) {
				intervals.push(i_date);
				i>0 ? i++ : i--;
			} else {
				if (i>0) { // go up
					i = -1;
				} else { // no hour window
					fail = true;
				}
			}
		}
		return !fail && intervals;
	};

	checkAround = (table_id, date) => {
		return this.getHookahHourIntervals(table_id, date);
	};

	isCellAvailable = (table_id, date) => {
		const {status} = this.checkInterval(table_id, date, true);
		return status === enums.CELL.AVAILABLE;
	};

	checkInterval = (table_id, date, no_recursive) => {
		const {
			settings: {interval, safeTime, hookahHour, maxHookahHours},
			bookings,
			intervals,
			selectedTableId,
			selectedIntervals,
		} = this.props;

		const bookingsList = bookings.get('list').toJS();
		const someSelected = selectedIntervals.length;

		let status;
		let onClick = () => ({});
		let params = {};

		const insideIntervals = intervals.find(_interval => {
			return _interval.getTime() === date.getTime();
		});
		if (insideIntervals) {
			// сначала проверяем не забронирован ли интервал
			const booked = bookingsList.some(booking => {
				return booking.table_id === table_id
					&& date >= booking.from
					&& date < booking.till;
			});
			if (booked) {
				status = enums.CELL.BOOKED;
			} else {
				// потом проверяем не является ли он безопасным промежутком между бронями
				const cantBeBooked = safeTime>0 && bookingsList.some(booking => {
					return booking.table_id === table_id
						&& (
							Math.abs(date - booking.from)/1000/60 <= safeTime
							|| Math.abs(date - booking.till)/1000/60 < safeTime
						);
				});
				if (cantBeBooked) {
					status = enums.CELL.DISABLED;
				} else {
					// если есть уже выбранные интервалы, то проверяем дальше
					if (someSelected) {
						const hookahHourSpan = Math.round(hookahHour/interval);
						// проверяем не выбран ли интервал
						const choosedIndex = selectedTableId === table_id
							&& selectedIntervals.findIndex(_interval => {
								return _interval.date.getTime() === date.getTime();
							});
						if (choosedIndex !== false && choosedIndex > -1) {
							status = enums.CELL.CHOOSED;
							params.rowSpan = choosedIndex % hookahHourSpan === 0 ? hookahHourSpan : 0;
							const {first, last} = selectedIntervals[choosedIndex];
							params = {...params, first, last};
							// при клике на верхнюю половину выбранных интервалов убираем сверху, иначе снизу
							let unselect_group_id = null;
							if ((choosedIndex+1)/selectedIntervals.length <= 1/2) {
								unselect_group_id = [...selectedIntervals].shift().group_id;
							} else {
								unselect_group_id = [...selectedIntervals].pop().group_id;
							}
							onClick = () => this.onUnselectGroup(unselect_group_id);
						} else {
							// потом проверяем может ли интервал быть выбран следующим
							const canBeChoosed = selectedTableId === table_id
								&& selectedIntervals.length < maxHookahHours*hookahHour/interval
								&& selectedIntervals.some(interval => {
									return Math.abs(interval.date - date)/1000/60 <= hookahHour; // diff less then 1 hookah hour
								});
							if (canBeChoosed) {
								status = enums.CELL.AVAILABLE;
								if (!no_recursive) {
									// проверяем статус предыдущего интервала
									const {prevStatus} = this.checkPrevInterval(table_id, date);
									params.rowSpan = prevStatus !== enums.CELL.AVAILABLE ? hookahHourSpan : 0;
								}
								onClick = () => this.onSelectHookahHour(table_id, date);
							} else {
								status = enums.CELL.DISABLED;
							}
						}
					} else {
						status = enums.CELL.AVAILABLE;
						onClick = () => this.onSelectHookahHour(table_id, date);
					}
				}
			}
		} else {
			status = enums.CELL.NONE;
		}

		return {status, onClick, params};
	};

	checkPrevInterval = (table_id, date) => {
		const {
			settings: {interval},
		} = this.props;
		const prevDate = moment(date).subtract({minutes: interval}).toDate();
		const {status: prevStatus} = this.checkInterval(table_id, prevDate, true);
		return {prevStatus};
	}

	render() {
		const {
			settings: {maxBookings, interval},
			myBookings,
			bookings,
			tables,
			intervals,
			selectedTableId,
			selectedIntervals,
			showSwipe,
		} = this.props;

		const loading = bookings.get('loading')
			&& tables.get('loading');

		const tablesList = tables.get('list',[]).toJS();
		const {list: myBookingsList} = myBookings.toJS();
		const myBookingsCount = myBookingsList.length;

		const containerClassName = 'table book' + (selectedIntervals.length ? ' selected' : '');

		return (
			<div className="table-wrapper">
				{!loading &&
				<Fragment>
					<div className="table-responsive">
						<table className={containerClassName}>
							<thead>
								<tr>
									<td />
									{tablesList.map(table => (
										<td key={`t${table.id}`} className={selectedTableId === table.id ? 'selected':''}>
											<span>{table.name}</span>
											<small>{table.seats}</small>
										</td>
									))}
									<td />
								</tr>
							</thead>
							<tbody>
								{intervals.toJS().map((date,i) => { // строчки
									const time = moment(date).format('HH:mm');
									const selectedTime = selectedIntervals.find(_interval => {
										return _interval.date.getTime() === date.getTime();
									});
									return (
										<tr key={`i${i}`} className={selectedTime ? 'selected':''}>
											<td className="time"><span>{time}</span></td>
											{tablesList.map(table => { // ячейки
												let {status, onClick, params} = this.checkInterval(table.id, date);
												const classNames = [];

												if (status === enums.CELL.AVAILABLE) {
													// если не хватает места между бронями
													if (!this.checkAround(table.id, date)) {
														status = enums.CELL.DISABLED;
														params.rowSpan = null;
													}

													// если превышено общее число броней
													if (myBookingsCount >= maxBookings) {
														onClick = () => {
															this.props.warn('К сожалению, вы не можете забронировать более чем ' + maxBookings + ' '
																+ pluralize(maxBookings,'стол','стола','столов') + ' одновременно');
														};
													}
												}

												if (status === enums.CELL.CHOOSED) {
													if (params.first) {
														classNames.push('first');
													}
													if (params.last) {
														classNames.push('last');
													}
												}

												if (params.rowSpan === 0) {
													return null;
												}
												classNames.push(status);

												return (
													<td key={`i${i}-t${table.id}`} rowSpan={params.rowSpan} className={classNames.join(' ')} onClick={onClick} />
												);
											})}
											<td className="time"><span>{time}</span></td>
										</tr>
									);
								})}
							</tbody>
							<tfoot>
								{intervals.size>0 && [intervals.last()].map((date,i) => {
									const time = moment(date).add({minutes: interval}).format('HH:mm');
									const selectedTime = selectedIntervals.find(_interval => {
										return _interval.date.getTime() === date.getTime();
									});
									return (
										<tr key={i} className={selectedTime ? 'selected':''}>
											<td className="time"><span>{time}</span></td>
											<td colSpan={tablesList.length} />
											<td className="time"><span>{time}</span></td>
										</tr>
									);
								})}
								{intervals.size === 0 &&
								<tr>
									<td className="time" />
									<td className="text-center" colSpan={tablesList.length}>Нет доступного времени для бронирования</td>
									<td className="time" />
								</tr>}
							</tfoot>
						</table>
					</div>
					<table className="clone">
						<thead>
							<tr>
								<td />
							</tr>
						</thead>
						<tbody>
							{intervals.toJS().map((date,i) => { // строчки
								const time = moment(date).format('HH:mm');
								const selectedTime = selectedIntervals.find(_interval => {
									return _interval.date.getTime() === date.getTime();
								});
								return (
									<tr key={`i${i}`} className={selectedTime ? 'selected':''}>
										<td className="time-clone"><span>{time}</span></td>
									</tr>
								);
							})}
						</tbody>
						<tfoot>
							{intervals.size>0 && [intervals.last()].map((date,i) => {
								const time = moment(date).add({minutes: interval}).format('HH:mm');
								const selectedTime = selectedIntervals.find(_interval => {
									return _interval.date.getTime() === date.getTime();
								});
								return (
									<tr key={i} className={selectedTime ? 'selected':''}>
										<td className="time-clone"><span>{time}</span></td>
									</tr>
								);
							})}
						</tfoot>
					</table>
				</Fragment>}

				<Loader loading={loading} />

				{showSwipe &&
				<div className="swipe rounded-circle" />}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/book/BookTable.js